<script lang="ts">
  import { focus } from "./actions/focus";
  import DialogBase from "./DialogBase.svelte";
  import { createJottacloudConfig } from "./fs";
  import { jottaLogin, makeFileSystemJottacloud } from "./fs-jottacloud";
  import { captureEvent, telegramNotify } from "./http";
  import { showMessage } from "./message";

  interface Props {
    open?: boolean;
    mountfs: (fs: any) => void;
  }

  let { open = $bindable(false), mountfs }: Props = $props();

  let config = $state(createJottacloudConfig());
  let loginToken = $state("");
  let testingConnection = $state(false);
  let errorMessage = $state("");

  let canConnect = $derived(loginToken.trim() != "" && !testingConnection);

  async function onConnect() {
    testingConnection = true;
    errorMessage = "";
    let removeMsg = showMessage("logging in to Jottacloud");
    try {
      await jottaLogin(config, loginToken.trim());
      // the token is used up
      loginToken = "";
      let who = config.email || config.user;
      config.name = config.name.trim() || who;
      let fs = makeFileSystemJottacloud(config);
      telegramNotify(`New Jottacloud connection for ${who}`);
      captureEvent("jottacloud-login", {});
      removeMsg();
      mountfs(fs);
      open = false;
    } catch (e) {
      console.error(e);
      errorMessage = (e as Error).toString();
      removeMsg();
    }
    testingConnection = false;
  }

  function close() {
    open = false;
  }
</script>

<DialogBase bind:open title="Connect Jottacloud">
  {#snippet main()}
    <div class="flex flex-col text-sm">
      <label for="input-jottacloud-name">Name: <span class="text-gray-400">(optional)</span></label>
      <input
        use:focus
        type="text"
        id="input-jottacloud-name"
        autocomplete="off"
        class="outline-hidden border px-2 py-1"
        bind:value={config.name}
      />

      <label class="mt-3" for="input-jottacloud-token">Personal login token:</label>
      <input
        type="password"
        id="input-jottacloud-token"
        autocomplete="off"
        class="outline-hidden border px-2 py-1"
        bind:value={loginToken}
      />

      <div class="mt-3 w-72 text-gray-500">
        Generate a personal login token in
        <a class="underline" href="https://www.jottacloud.com/web/secure" target="_blank" rel="noopener noreferrer"
          >Jottacloud's security settings</a
        >. A token works once: Sumatra File Manager Online trades it for access that it keeps in this browser. Files are
        those in Jottacloud's Archive.
      </div>

      {#if errorMessage}
        <div class="mt-2 mb-2 w-72 font-medium break-all text-red-500">
          {errorMessage}
        </div>
      {/if}
    </div>
  {/snippet}

  {#snippet bottom()}
    <div class="flex flex-row justify-between">
      <button onclick={close} class="dlg-btn">Cancel</button>
      <button disabled={!canConnect} onclick={onConnect} class="dlg-btn">Connect Jottacloud</button>
    </div>
  {/snippet}
</DialogBase>
